import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Demos/Button';

import { buttonCTA } from './types';

import './ctabuttons.scss';

function CTAButtons({
  buttons = {
    close: null,
    next: null,
    helpdesk: null,
    hardware: null,
  },
}) {
  const { close, next, helpdesk, hardware } = buttons;
  return (
    <div className="ctas-container">
      {close && <Button text="Back" {...close} className="close-cta" />}
      {helpdesk && (
        <Button text="Helpdesk Chat" {...helpdesk} className="hardware-cta" />
      )}
      {hardware && (
        <Button
          text="Order Hardware"
          {...hardware}
          className="assistance-cta"
        />
      )}
      {next && <Button text="Next" {...next} className="next-cta" />}
    </div>
  );
}

CTAButtons.propTypes = {
  buttons: PropTypes.objectOf(buttonCTA),
};

export default CTAButtons;
